import React from 'react';
import { Text, UnstyledButton } from '@/shared/ui';
import { MiniCalendar } from '../MiniCalendar';

interface MobileMonthPickerSheetProps {
  anchor: Date;
  onSelectDate: (date: Date) => void;
  onClose: () => void;
}

/**
 * Mobile bottom-sheet with a mini calendar for month/date jumping.
 *
 * @param props Anchor date, select handler, and close handler.
 * @returns Rendered month picker sheet.
 */
export const MobileMonthPickerSheet: React.FC<MobileMonthPickerSheetProps> = ({
  anchor,
  onSelectDate,
  onClose,
}) => (
  <div data-testid="agenda-month-sheet" role="dialog" aria-modal="true">
    <UnstyledButton
      type="button"
      aria-hidden="true"
      tabIndex={-1}
      data-testid="agenda-month-scrim"
      onClick={onClose}
      className="fixed inset-x-0 top-0 bottom-0 z-1001 bg-[var(--overlay-scrim)]"
    >
      {null}
    </UnstyledButton>
    <div
      data-testid="agenda-month-sheet-panel"
      className="fixed inset-x-0 bottom-0 z-1003 w-full rounded-t-[var(--radius-lg)] bg-[var(--surface-primary)] px-(--space-4) pt-(--space-4) shadow-[var(--shadow-overflow-sheet)]"
      style={{
        animation: 'none',
        paddingBottom:
          'calc(var(--bottom-nav-height, 52px) + env(safe-area-inset-bottom, 0px))',
      }}
    >
      <Text
        component="span"
        aria-hidden="true"
        className="mx-auto mb-(--space-3) block h-1 w-12 rounded-full bg-[var(--border-subtle)]"
      />
      <MiniCalendar anchor={anchor} onSelectDate={onSelectDate} />
    </div>
  </div>
);
